export const USER_SYMBOL = "USER_SYMBOL";
export const IS_MOBILE_SYMBOL = "IS_MOBILE_SYMBOL";
export const API_ENDPOINT_SYMBOL = "API_ENDPOINT_SYMBOL";
export const PLATFORM_SYMBOL = "PLATFORM_SYMBOL";
export type TDrawerState = "show" | "hide" | "mini" | null;
